import { useMutation } from "@apollo/client";

import { ValidateUserPrefillMutation, ValidateUserPrefillMutationVariables } from "@ctypes";
import { USER, VALIDATE_USER_PREFILL } from "@graphql";

export const useValidateUserPrefill = () => {
  return useMutation<ValidateUserPrefillMutation, ValidateUserPrefillMutationVariables>(
    VALIDATE_USER_PREFILL,
    {
      refetchQueries: [{ query: USER }],
      awaitRefetchQueries: true,
    },
  );
};
